export default __webpack_public_path__ + "34abbd9fbd602a087cacaf79b317a931.svg";